<template>
    <rkm-modal
        large
        ref="Modal"
        title="Procedimento realizado previamente"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="procedimentos"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        show-default-option
                        text-field="descricao"
                        v-model="model.procedimentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                @click="$refs.Form.validate(include)"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                procedimento: { required: true }
            }
        }
    },
    data: () => ({
        model: {
            procedimentoId: null
        }
    }),
    methods: {
        open() {

            this.resetForm()

            this.$refs.Modal.show()
        },
        resetForm() {

            this.model.procedimentoId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        include() {

            const procedimento = this.procedimentos.find(p => p.id === this.model.procedimentoId)

            if (this.procedimentosIncluidos.find(p => p.procedimentoCodigo === procedimento.codigo)) {

                this.showValidationNotification('Este procedimento já foi incluído')

                return
            }

            this.procedimentosIncluidos.push({
                id: null,
                procedimentoId: procedimento.id,
                procedimentoCodigo: procedimento.codigo,
                procedimentoDescricao: procedimento.descricao,
                dataExecutada: null,
                unidadeExecutoraId: null,
                ocupacaoExecutora: null,
                usuarioExecutorNome: null,
            })

            this.$refs.Modal.hide()
        }
    },
    props: {
        procedimentosIncluidos: { type: Array, required: true },
        procedimentos: { type: Array, required: true },
    }

}
</script>